<template>
  <v-row class="my-0">
    <v-col class="americansystem__col py-0" :cols="12">
      <!-- Campo de la fórmula -->
      <ValidationProvider
        vid="label"
        :name="'main-' + String(inx)"
        :rules="{ required: true, decimals: 2, min_value: 0 }"
        v-slot="{ errors }"
      >
        <v-text-field
          color="secondary"
          outlined
          type="tel"
          :disabled="readonly"
          :error-messages="errors[0]"
          :label="label"
          :suffix="measureConvert"
          @keyup="unformat"
          v-model="main"
        >
          <div slot="prepend">
            <v-icon
              color="info"
              small
              @click="show = !show"
              v-text="'fa-info-circle'"
            />
          </div>
        </v-text-field>
      </ValidationProvider>

      <!-- Popover de información de la fórmula -->
      <v-alert
        class="americansystem__alert"
        border="top"
        colored-border
        close-icon="mdi-close"
        dense
        dismissible
        elevation="2"
        type="info"
        v-model="show"
      >
        <!-- Decimal -->
        <template v-if="isDecimalMeasure">
          <span
            v-if="
              dimensions !== undefined &&
              dimensions[name] !== undefined &&
              dimensions[name]['value'] !== undefined &&
              dimensions[name]['value'] !== ''
            "
          >
            {{ dimensions[name]['value'] }} {{ measureConvert }}
          </span>
          <span v-else> {{ main }} {{ measureConvert }} </span>
        </template>

        <span v-if="measureConvert === 'in'">
          {{ main }} {{ decimalText }} {{ measureConvert }}
        </span>
        <span v-if="measureConvert === 'ft'">
          {{ main }} ft {{ second }} {{ decimalText }} in
        </span>
        <span
          v-if="
            rounded !== undefined &&
            rounded &&
            dimensions !== undefined &&
            dimensions[name] !== undefined &&
            dimensions[name]['value'] !== undefined &&
            dimensions[name]['value'] !== ''
          "
        >
          {{ $t('rounded2') }}:
          {{ dimensions[name].rounded }}
          {{ defaultMeasure !== undefined ? defaultMeasure : measureConvert }}
        </span>
      </v-alert>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    readonly: {
      default: false,
      type: Boolean
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      required: true,
      type: [Number, String],
      default: 0
    },
    measure: {
      type: [String]
    },
    defaultMeasure: {
      type: [String]
    },
    inx: {
      type: [String, Number]
    },
    dimensions: Object,
    rounded: Boolean
  },
  data() {
    return {
      formatted: false,
      main: 0,
      second: 0,
      decimal: 0,
      numerator: 0,
      denominator: 1,
      show: false,
      decimalText: '0',
      decimals: [
        '0',
        '1/16',
        '1/8',
        '3/16',
        '1/4',
        '5/16',
        '3/8',
        '7/16',
        '1/2',
        '9/16',
        '5/8',
        '11/16',
        '3/4',
        '13/16',
        '7/8',
        '15/16'
      ],
      transform: {
        in: {
          ft: { value: 0.083333, method: '*' },
          m: { value: 39.37, method: '/' },
          mm: { value: 0.03937, method: '/' },
          cm: { value: 0.3937, method: '/' }
        },
        ft: {
          in: { value: 0.083333, method: '/' },
          m: { value: 3.2808, method: '/' },
          mm: { value: 0.0032808, method: '/' },
          cm: { value: 0.032808, method: '/' }
        },
        m: {
          in: { value: 39.37, method: '*' },
          ft: { value: 3.2808, method: '*' },
          mm: { value: 1000, method: '*' },
          cm: { value: 100, method: '*' }
        },
        mm: {
          in: { value: 0.03937, method: '*' },
          ft: { value: 0.0032808, method: '*' },
          m: { value: 1000, method: '/' },
          cm: { value: 10, method: '/' }
        },
        cm: {
          in: { value: 0.3937, method: '*' },
          ft: { value: 0.032808, method: '*' },
          m: { value: 100, method: '/' },
          mm: { value: 10, method: '*' }
        }
      }
    }
  },
  methods: {
    changeDecimal() {
      this.decimal = eval(this.decimalText)
      this.unformat()
    },
    getFraction(fraction) {
      var gcd = function (a, b) {
        if (b < 0.0000001) return a // Since there is a limited precision we need to limit the value.
        return gcd(b, Math.floor(a % b)) // Discard any fractions due to limitations in precision.
      }
      var len
      if (typeof fraction === 'number') {
        len = fraction.toString().length - 2
      } else {
        len = fraction.length - 2
        fraction = Number(fraction)
      }

      var denominator = Math.pow(10, len)
      var numerator = fraction * denominator

      var divisor = gcd(numerator, denominator) // Should be 5

      numerator /= divisor // Should be 687
      denominator /= divisor
      return `${Math.floor(numerator)}/${Math.floor(denominator)}`
    },
    format() {
      let separator = []
      const IN_PER_FT = 1 / 12
      switch (this.measureConvert) {
        case 'in':
          separator =
            this.dimensions !== undefined &&
            this.dimensions[this.name] !== undefined &&
            this.dimensions[this.name]['value'] !== undefined &&
            this.dimensions[this.name]['value'] !== ''
              ? (this.dimensions[this.name]['value'] + '').split('.')
              : (this.value + '').split('.')
          this.main = Number(separator[0])
          this.decimalText =
            this.dimensions !== undefined &&
            this.dimensions[this.name] !== undefined &&
            this.dimensions[this.name]['decimalText'] !== undefined &&
            this.dimensions[this.name]['decimalText'] !== ''
              ? this.dimensions[this.name]['decimalText']
              : '0'
          this.decimal = eval(this.decimalText)
          break
        case 'ft':
          separator =
            this.dimensions !== undefined &&
            this.dimensions[this.name] !== undefined &&
            this.dimensions[this.name]['value'] !== undefined &&
            this.dimensions[this.name]['value'] !== ''
              ? (this.dimensions[this.name]['value'] + '').split('.')
              : (this.value + '').split('.')
          this.main = Number(separator[0])
          this.decimalText =
            this.dimensions !== undefined &&
            this.dimensions[this.name] !== undefined &&
            this.dimensions[this.name]['decimalText'] !== undefined &&
            this.dimensions[this.name]['decimalText'] !== ''
              ? this.dimensions[this.name]['decimalText']
              : '0'
          this.decimal = eval(this.decimalText)
          separator =
            Number(`0.${separator[1] === undefined ? 0 : separator[1]}`) /
            IN_PER_FT
          separator = (separator + '').split('.')
          this.second = Number(separator[0])
          break
        default:
          if (
            this.dimensions !== undefined &&
            this.dimensions[this.name] !== undefined &&
            this.dimensions[this.name]['value'] !== undefined &&
            this.dimensions[this.name]['value'] !== ''
          ) {
            this.main = Number(this.dimensions[this.name]['value']).toFixed(2)
          } else if (
            this.measure !== undefined &&
            this.defaultMeasure !== undefined &&
            this.measure.toLowerCase() !== this.defaultMeasure.toLowerCase() &&
            this.transform[this.defaultMeasure.toLowerCase()] !== undefined &&
            this.transform[this.defaultMeasure.toLowerCase()][
              this.measure.toLowerCase()
            ] !== undefined
          ) {
            this.main = this.conversor(
              this.defaultMeasure.toLowerCase(),
              this.measure.toLowerCase(),
              this.value
            )
          } else {
            this.main = Number(this.value).toFixed(2)
          }
          break
      }
      if (this.formatted) {
        this.formatted = false
        let dimension = {
          ...this.dimensions[this.name],
          measure: this.measureConvert,
          decimalText: this.decimalText,
          main: this.main,
          second: this.second,
          name: this.label
        }
        this.$emit('changedimensions', {
          ...this.dimensions,
          [this.name]: dimension
        })
      }
    },
    unformat() {
      let val = 0
      const IN_PER_FT = 1 / 12

      switch (this.measureConvert) {
        case 'in':
          val = Number(this.main) + Number(this.decimal)
          val = Number(val).toFixed(2)
          break
        case 'ft':
          val = Number(this.main)
          val += (Number(this.second) + Number(this.decimal)) * IN_PER_FT
          val = Number(val).toFixed(2)
          break
        default:
          val = Number(this.main).toFixed(2)
          break
      }
      let dimension = {
        value: val,
        measure: this.measureConvert,
        decimalText: this.decimalText,
        main: this.main,
        second: this.second,
        name: this.label
      }
      if (
        this.measure !== undefined &&
        this.defaultMeasure !== undefined &&
        this.measure.toLowerCase() !== this.defaultMeasure.toLowerCase() &&
        this.transform[this.measureConvert] !== undefined &&
        this.transform[this.measureConvert][
          this.defaultMeasure.toLowerCase()
        ] !== undefined
      ) {
        dimension['defaultMeasure'] = this.defaultMeasure.toLowerCase()
        val = this.conversor(
          this.measure.toLowerCase(),
          this.defaultMeasure.toLowerCase(),
          val
        )
        dimension['defaultValue'] = val
      }
      if (this.rounded !== undefined && this.rounded) {
        if (this.measureConvert === 'in' || this.measureConvert === 'ft') {
          val = Math.ceil(val)
        } else {
          val = Math.round(val)
        }
        dimension = { ...dimension, rounded: val }
      }
      this.$emit('input', val)
      this.$emit('changedimensions', {
        ...this.dimensions,
        [this.name]: dimension
      })
    },
    conversor(old, newVal, valre) {
      let dimension =
        this.dimensions[this.name] === undefined
          ? {}
          : this.dimensions[this.name]
      dimension['measure'] = newVal
      if (
        this.transform[old] !== undefined &&
        this.transform[old][newVal] !== undefined
      ) {
        let val =
          this.dimensions !== undefined &&
          this.dimensions[this.name] !== undefined &&
          this.dimensions[this.name]['value'] !== undefined &&
          this.dimensions[this.name]['value'] !== ''
            ? this.dimensions[this.name]['value']
            : this.value
        if (valre !== undefined) {
          val = valre
        }
        let calc = eval(
          `${val}${this.transform[old][newVal]['method']}${this.transform[old][newVal]['value']}`
        ).toFixed(2)
        if (valre === undefined) {
          dimension['value'] = calc
          if (
            this.measure !== undefined &&
            this.defaultMeasure !== undefined &&
            this.measure.toLowerCase() !== this.defaultMeasure.toLowerCase() &&
            this.transform[this.measureConvert] !== undefined &&
            this.transform[this.measureConvert][
              this.defaultMeasure.toLowerCase()
            ] !== undefined
          ) {
            dimension['defaultMeasure'] = this.defaultMeasure.toLowerCase()
            calc = this.conversor(
              this.measure.toLowerCase(),
              this.defaultMeasure.toLowerCase(),
              calc
            )
            dimension['defaultValue'] = calc
          }
          this.$emit('changedimensions', {
            ...this.dimensions,
            [this.name]: dimension
          })
          this.$emit('input', calc)
          this.formatted = true
        } else {
          return calc
        }
      } else if (valre !== undefined) {
        return valre
      } else {
        this.$emit('changedimensions', {
          ...this.dimensions,
          [this.name]: dimension
        })
      }
    }
  },
  computed: {
    measureConvert() {
      return this.measure !== null && this.measure !== undefined
        ? this.measure.toLowerCase()
        : ''
    },
    isDecimalMeasure() {
      const imperialMeasures = ['ft', 'in']
      return !imperialMeasures.includes(this.measureConvert)
    }
  },
  watch: {
    formatted: {
      immediate: true,
      handler(val) {
        if (val) {
          this.format()
        }
      }
    },
    rounded: {
      immediate: true,
      handler(val) {
        if (
          (val !== undefined && val) ||
          (!val &&
            this.dimensions !== undefined &&
            this.dimensions[this.name] !== undefined &&
            this.dimensions[this.name]['rounded'] !== undefined)
        ) {
          this.unformat()
        }
      }
    },
    measure: {
      immediate: true,
      handler(val, oldval) {
        if (oldval !== '' && oldval !== undefined && oldval !== null) {
          this.conversor(oldval.toLowerCase(), val.toLowerCase())
        } else if (oldval !== val) {
          this.format()
        }
      }
    }
  }
}
</script>
<style lang="sass">
.americansystem__col
  position: relative

.americansystem__alert
  position: absolute
  padding: 10px 16px
  padding-bottom: 0
  margin-bottom: 0
  color: var(--v-primary-base)
  font-weight: 900
  font-size: 14px
  z-index: 1000
  top: 58px
  left: 10px
  .v-alert__wrapper
    padding-top: 0px
    padding-bottom: 10px
    .v-icon
      align-self: center
</style>
